import { render, staticRenderFns } from "./DetailsPageToolbar.vue?vue&type=template&id=93127fca&scoped=true&"
import script from "./DetailsPageToolbar.vue?vue&type=script&lang=js&"
export * from "./DetailsPageToolbar.vue?vue&type=script&lang=js&"
import style0 from "./DetailsPageToolbar.vue?vue&type=style&index=0&id=93127fca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93127fca",
  null
  
)

export default component.exports